document.addEventListener("DOMContentLoaded", () => {
    const navigationToogle = document.querySelector(".navigation__toggle");
    const sideMenu = document.querySelector(".side-menu");
    const backdrop = document.querySelector(".backdrop");

    // Toogle side menu
    navigationToogle.addEventListener("click", () => {
        sideMenu.classList.toggle("side-menu--active");
        navigationToogle.classList.toggle("open");
        backdrop.classList.toggle("active");
        document.body.classList.toggle("no-scroll");
        
    });

    // Close navigation on backdrop click
    backdrop.addEventListener('click', () => {
        setTimeout(() => {
            sideMenu.classList.remove('side-menu--active');
            navigationToogle.classList.remove("open");
            backdrop.classList.remove('active');
            document.body.classList.remove("no-scroll");
        }, 0);
    });
});